import {FunctionComponent} from 'react';
import Dialog from '@/components/dialog';
import {useWebViewContentOnDialogAppear} from '@/hooks/analytics/use-web-view-content-on-dialog-appear';

interface HelperDialogProps {
  isVisible: boolean;
  onClose: () => void;
  title?: string;
  content?: string;
  identifier: string;
}

const HelperDialog: FunctionComponent<HelperDialogProps> = ({isVisible, onClose, title, content, identifier}) => {
  useWebViewContentOnDialogAppear('modale-aide-contenu', null, isVisible);

  return (
    <Dialog isVisible={isVisible} onClose={onClose}>
      <Dialog.Header title={title || ''} onClose={onClose} />

      <Dialog.Content>
        <div data-testid={`${identifier}-helper-content`} className="whitespace-pre-wrap">
          <div
            className="flex flex-col gap-2 [&>ul]:flex [&>ul]:flex-col [&>ul]:gap-2 [&_li]:ml-4 [&_li]:list-disc"
            dangerouslySetInnerHTML={{__html: content || ''}}
          />
        </div>
      </Dialog.Content>
    </Dialog>
  );
};

export default HelperDialog;
